import { WS_DATA, APP } from './app.constants';

export const ALARMS = `${APP}_alarms`;
export const SHARE_ALARMS = `${ALARMS}/SHARE_ALARMS`;
export const CLOSE_ALARMS = `${ALARMS}/CLOSE_ALARMS`;
export const OPEN_ALARMS = `${ALARMS}/OPEN_ALARMS`;
export const CANCEL_ALARMS = `${ALARMS}/CANCEL_ALARMS`;
export const SET_RECORDING = `${ALARMS}/SET_RECORDING`;
export const GET_SAFETY_REGIONS = `${ALARMS}/GET_SAFETY_REGIONS`;
export const SAFETY_REGIONS_CHANGED = `${ALARMS}/SAFETY_REGIONS_CHANGED`;
export const WS_DATA_ALARM = `${WS_DATA}/alarm`;
export const WS_DATA_ALARMS = `${WS_DATA}/alarms`;
export const WS_DATA_ASS_REQUEST = `${WS_DATA}/assistanceRequest`;
export const WS_DATA_ASS_REQUESTS = `${WS_DATA}/assistanceRequests`;
export const WS_FORCE_RELOAD = `${WS_DATA}/forceReload`;
export const WS_REQUEST_RELOAD_DATA = `${WS_DATA}/requestReloadData`;
export const SET_ALARM_SOUND_ENABLED = `${WS_DATA}/SET_ALARM_SOUND_ENABLED`;
export const SET_ALERT_SOUND_ENABLED = `${WS_DATA}/SET_ALERT_SOUND_ENABLED`;
export const SET_ASS_REQ_SOUND_ENABLED = `${WS_DATA}/SET_ASS_REQ_SOUND_ENABLED`;
export const SET_DETAILED_ALARM = `${ALARMS}/SET_DETAILED_ALARM`;
export const TOGGLE_ARC_ALARMS = `${ALARMS}/TOGGLE_ARC_ALARMS`;
export const SAVE_EXPIRATION_TIME = `${ALARMS}/SAVE_EXPIRATION_TIME`;
export const FETCH_V4_ALARMS = `${ALARMS}/FETCH_V4_ALARMS`;
export const REFRESH_V4_ALARMS = `${ALARMS}/REFRESH_V4_ALARMS`;
export const V4_ALARMS_LOADED = `${ALARMS}/V4_ALARMS_LOADED`;
export const V4_ALARMS_CLOSED = `${ALARMS}/V4_ALARMS_CLOSED`;
export const V4_ALARM_FORWARDING_CHANGED = `${ALARMS}/V4_ALARM_FORWARDING_CHANGED`;
export const V4_ALARM_CLOSED_LIVE = `${ALARMS}/V4_ALARM_CLOSED_LIVE`;
export const V4_ALARM_UPDATED_LIVE = `${ALARMS}/V4_ALARM_UPDATED_LIVE`;
export const FETCH_V4_CLOSED_ALARMS = `${ALARMS}/FETCH_V4_CLOSED_ALARMS`;
export const REFRESH_V4_CLOSED_ALARMS = `${ALARMS}/REFRESH_V4_CLOSED_ALARMS`;
export const V4_CLOSED_ALARMS_LOADED = `${ALARMS}/V4_CLOSED_ALARMS_LOADED`;
export const V4_CLOSED_ALARMS_RESET = `${ALARMS}/V4_CLOSED_ALARMS_RESET`;
export const SET_ALARM_LOCATION_VIEW = `${ALARMS}/SET_ALARM_LOCATION_VIEW`;
export const LATEST_ALARM_POSITION_LOADED = `${ALARMS}/LATEST_ALARM_POSITION_LOADED`;
export const LATEST_ALARM_POSITION_FAILED = `${ALARMS}/LATEST_ALARM_POSITION_FAILED`;
